import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';

import { IInutilizarNum, ISerieFiscal } from '../model/serie_fiscal.model';

@Injectable()
export class SerieFiscalService extends EntityService<ISerieFiscal> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'serie_fiscal',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Pega series disponiveis para um terminal
   * @param pagination
   * @param include
   * @param where
   * @returns
   */
  disponiveis(
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    ambiente: string,
    serie_fiscal_id?: string,
    where?: { field: string; value: string }
  ) {
    const url = `${this.baseURL}/disponiveis`;
    let params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    // FIXME: ADICIONAR O FILTRO DE DOMAIN_ORG_ID
    if (serie_fiscal_id)
      params = params.append('serie_fiscal_id', serie_fiscal_id);

    if (include) params = params.append('include', include.join(','));

    if (where) params = params.append(`${where.field}`, where.value);

    if (ambiente) params = params.append('ambiente', ambiente);

    return this.http.get<any>(url, {
      params,
      headers: this.getHeader()
    });
  }

  inutilizarNumSerieFiscal(
    body: IInutilizarNum,
    serie_fiscal_id: string
  ): Observable<any> {
    const url = `${this.baseURL}/${serie_fiscal_id}/inutilizar_sequencia`;

    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http.put<any>(url, body, { headers });
  }
}
